import { SET_LOADING_CONFIRM_SUCCESS } from '../types/confirmActionsTypes'

export type ConfirmAction = ConfirmsAction

// Esto va a REDUX
export interface ConfirmsAction {
  type: typeof SET_LOADING_CONFIRM_SUCCESS
  isLoadingConfirm: boolean
}

export const setLoadingConfirmsAction = (
  isLoadingConfirm: boolean
): ConfirmsAction => {
  return {
    type: SET_LOADING_CONFIRM_SUCCESS,
    isLoadingConfirm
  }
}
